import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation';
import {
	type AssistanceServiceInjectedParams,
	createHookWithAssistanceService,
	useQuery,
} from '@atlassian/conversation-assistant-service';

type UseAgentPermissions = {
	agentId: string;
	enabled: boolean;
} & AssistanceServiceInjectedParams;

export const useAgentPermissions = createHookWithAssistanceService(
	({
		agentId,
		enabled,
		assistanceServiceInjectedParams: { assistanceService, experienceTracker },
	}: UseAgentPermissions) => {
		const query = useQuery({
			queryKey: ['getAgentPermissions', agentId],
			queryFn: async () => {
				experienceTracker.start({
					id: ExperienceName.GET_AGENT_PERMISSIONS,
					name: ExperienceName.GET_AGENT_PERMISSIONS,
				});

				return await assistanceService.getAgentPermissions(agentId, {
					permission_ids: [
						'AGENT_CREATE',
						'AGENT_UPDATE',
						'AGENT_DELETE',
						'AGENT_DEACTIVATE',
						'AGENT_READ',
					],
				});
			},
			onSuccess: () => {
				experienceTracker.succeed({
					name: ExperienceName.GET_AGENT_PERMISSIONS,
				});
			},
			onError: (error) => {
				experienceTracker.fail({
					name: ExperienceName.GET_AGENT_PERMISSIONS,
					error,
				});
			},
			enabled,
		});

		return query;
	},
);
